
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { cleanUpHttpParams } from './toCleanHttpParams';

/**
 * Strip out any `undefined` parameters in the query string.
 * angular HttpParams include all undefined properties, this causes query string to become ?param1=undefined
 * this breaks C# controllers that receive the string "undefined" as value
 */
@Injectable()
export class StripUndefinedParams implements HttpInterceptor {

  /**
   * Iterate through query parameters and remove all those that are `undefined`.
   *
   * @param request The incoming request.
   * @param next The next handler.
   * @returns The handled request.
   */
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let params = request.params;

    params = cleanUpHttpParams(params);

    request = request.clone({ params });
    return next.handle(request);
  }
}
